module.exports = __webpack_public_path__ + "static/cloud_texture.01af96b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mb/cloud_texture.png
// module id = 69
// module chunks = 246384609461072 263791100135453 269829036549620